import { render, staticRenderFns } from "./mb-text-field.vue?vue&type=template&id=01eec7a6&"
import script from "./mb-text-field.vue?vue&type=script&lang=ts&"
export * from "./mb-text-field.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports